import {Language} from "modules/enums";
import logo from "assets/images/header-logo.png";
import logoFr from "assets/images/header-fr-logo.png";

export const logos = {
	[Language.English]: logo,
	[Language.French]: logoFr,
};
